import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchHomepageCategoriesData } from "../../actions/get-calls";
const Iprops = {
    HeaderClassName:'',
    subClassName:''
	
}
export default  function SpecializedDoctors (props = Iprops ){
    const[specialTittle, setSpecialTittle]=useState()
    const [specializedDoctors, setSpecializedDoctors] = useState();
	useEffect(() => {	
	
        fetchHomepageCategoriesData().then(function (response) {
            setSpecialTittle(response.data.data.doctorspeTitle[0])
            setSpecializedDoctors(response.data.data.doctorspeCategories)		
	})
	.catch(function (err) {
	});  
	}, []);
	
return(
    <section className="specialized-categories pb-0" >
				<div className="container">
					<h1 className={props.HeaderClassName}>
						{specialTittle?.main_heading}
					</h1>
					<p className={props.subClassName} dangerouslySetInnerHTML={{ __html: specialTittle?.description }}>			
					</p>

					<div className="row justify-content-center mt-4">
						{
							specializedDoctors ? specializedDoctors.map((category) => {
								return (
									<div className="col-lg-2 col-md-4 col-sm-4 col-6 mb-4" key={category._id}>
										<div className="spicialize-card">
											<div className="img-holder">
												<img src={category.img_url} alt={category.title} />
											</div>
											<p className="mb-0 mt-2">{category.title}</p>
											<Link
												to={category.redirection_url}
												// target={category.target_blank ? '_blank' : ''}
												rel={category.target_blank ? "noopener noreferrer" : ""}
												className="btn rounded-1  btn-light mt-2 ">
												Consult Now
											</Link>
										</div>
									</div>
								)
							}) : ''
						}
					</div>
		
				</div>
			</section>
)
}